<div class="container-fluid full-width">

  <div class="ups-component hero has-breadcrumbs">
    <div class="ups-container">
      <div class="card ups-card">
        <div class="card-img fade-in-up-light"><img src="../../../../assets/redesignImages/contact_us.png"
            alt="Woman packaging a box" title="Woman packaging a box" class="img-fluid" loading="lazy">
        </div>
        <div class="card-body fade-in-up-light">
          <div class="card-body-content">
            <h1 class="maj-head0">UPS Capital<sup class="contact-us_sup">®</sup></h1>
            <p class="maj-sub0">From insurance services to payments, you can make, move, and sell your goods with peace
              of mind.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="arc-container">
      <svg xmlns="" width="1440" class="arc" height="72" viewBox="0 0 1440 72" fill="none" aria-hidden="true"
        focusable="false">
        <path d="M-400 176C139.222 -24.794 1028.42 -10.941 1440 13.8751V176L-400 176Z" fill="white"></path>
      </svg>
    </div>
  </div>
  <div class="arc-container">
    <img class="business-services-curved-image" alt="background-arc" src="../../../../assets/redesignImages/Vector.png"
      width="1440" height="0">
  </div>



  <div class="row-common new-basic bus-ic max-1200 superior-coverage sub-heading container-fluid" id="skip-to-main">
    <h2 class="comm-head comm-pay-head">
      Let’s Connect</h2>
    <p></p>
    <p></p>

  </div>


  <div class="container input-form">
    <form class="form-st" #userForm="ngForm" (ngSubmit)="onSubmit()">
      <div class="form-group col lab-0">
        <label for="inputEmail4" class="visible-label">Required Fields <em class="em-style">*</em></label>
      </div>
      <div class="row sp-fm0">
        <div class="col dis_1">
          <input type="text" class="form-control" placeholder="First Name *" id="FirstName" aria-label="First Name *"
            #FirstName="ngModel" [(ngModel)]="user.FirstName" name="FirstName" required>
        </div>
        <div class="col dis_1">
          <input type="text" class="form-control" placeholder="Last Name *" id="LastName" aria-label="Last Name *"
            [(ngModel)]="user.LastName" name="LastName" required>
        </div>
      </div>
      <div class="row sp-fm0">
        <div class="col dis_1 ">
          <input type="text" class="form-control" aria-label="Company Name *" placeholder="Company Name *"
            [(ngModel)]="user.CompanyName" name="CompanyName">
        </div>
        <div class="col dis_1">
          <select id="inputState" aria-label="Country" class="form-select ds" [(ngModel)]="user.Country" name="Country"
            (change)="onCountryChange()">
            <option label="Country or Territory *" value="" disabled selected>Country or Territory *
            </option>
            <option label="Belgium" value="BE">Belgium</option>
            <option label="Canada" value="CA">Canada</option>
            <option label="China" value="CN">China</option>
            <option label="France" value="FR">France</option>
            <option label="Germany" value="DE">Germany</option>
            <option label="Hong Kong" value="HK">Hong Kong</option>
            <option label="Italy" value="IT">Italy</option>
            <option label="Mexico" value="MX">Mexico</option>
            <option label="Netherlands" value="NL">Netherlands</option>
            <option label="Poland" value="PL">Poland</option>
            <option label="Spain" value="ES">Spain</option>
            <option label="Thailand" value="TH">Thailand</option>
            <option label="United Kingdom" value="GB">United Kingdom</option>
            <option label="United States" value="US">United States</option>
          </select>
        </div>
      </div>
      <div class="row sp-fm0">
        <div class="col dis_1">
          <select id="StateProvinceRegion" aria-label="State" class="form-select ds"
            [(ngModel)]="user.StateProvinceRegion" name="StateProvinceRegion" [disabled]="!showState">
            <option value="" disabled="" selected="">State/Province</option>
            <option value="AK" class="US-State State-Options">Alaska</option>
            <option value="AZ" class="US-State State-Options">Arizona</option>
            <option value="AR" class="US-State State-Options">Arkansas</option>
            <option value="CA" class="US-State State-Options">California</option>
            <option value="CO" class="US-State State-Options">Colorado</option>
            <option value="CT" class="US-State State-Options">Connecticut</option>
            <option value="DE" class="US-State State-Options">Delaware</option>
            <option value="DC" class="US-State State-Options">District Of Columbia</option>
            <option value="FL" class="US-State State-Options">Florida</option>
            <option value="GA" class="US-State State-Options">Georgia</option>
            <option value="HI" class="US-State State-Options">Hawaii</option>
            <option value="ID" class="US-State State-Options">Idaho</option>
            <option value="IL" class="US-State State-Options">Illinois</option>
            <option value="IN" class="US-State State-Options">Indiana</option>
            <option value="IA" class="US-State State-Options">Iowa</option>
            <option value="KS" class="US-State State-Options">Kansas</option>
            <option value="KY" class="US-State State-Options">Kentucky</option>
            <option value="LA" class="US-State State-Options">Louisiana</option>
            <option value="ME" class="US-State State-Options">Maine</option>
            <option value="MD" class="US-State State-Options">Maryland</option>
            <option value="MA" class="US-State State-Options">Massachusetts</option>
            <option value="MI" class="US-State State-Options">Michigan</option>
            <option value="MN" class="US-State State-Options">Minnesota</option>
            <option value="MS" class="US-State State-Options">Mississippi</option>
            <option value="MO" class="US-State State-Options">Missouri</option>
            <option value="MT" class="US-State State-Options">Montana</option>
            <option value="NE" class="US-State State-Options">Nebraska</option>
            <option value="NV" class="US-State State-Options">Nevada</option>
            <option value="NH" class="US-State State-Options">New Hampshire</option>
            <option value="NJ" class="US-State State-Options">New Jersey</option>
            <option value="NM" class="US-State State-Options">New Mexico</option>
            <option value="NY" class="US-State State-Options">New York</option>
            <option value="NC" class="US-State State-Options">North Carolina</option>
            <option value="ND" class="US-State State-Options">North Dakota</option>
            <option value="OH" class="US-State State-Options">Ohio</option>
            <option value="OK" class="US-State State-Options">Oklahoma</option>
            <option value="OR" class="US-State State-Options">Oregon</option>
            <option value="PA" class="US-State State-Options">Pennsylvania</option>
            <option value="RI" class="US-State State-Options">Rhode Island</option>
            <option value="SC" class="US-State State-Options">South Carolina</option>
            <option value="SD" class="US-State State-Options">South Dakota</option>
            <option value="TN" class="US-State State-Options">Tennessee</option>
            <option value="TX" class="US-State State-Options">Texas</option>
            <option value="UT" class="US-State State-Options">Utah</option>
            <option value="VT" class="US-State State-Options">Vermont</option>
            <option value="VA" class="US-State State-Options">Virginia</option>
            <option value="WA" class="US-State State-Options">Washington</option>
            <option value="WV" class="US-State State-Options">West Virginia</option>
            <option value="WI" class="US-State State-Options">Wisconsin</option>
            <option value="WY" class="US-State State-Options">Wyoming</option>

            <option value="CH" class="State-Options MX-State">Chihuahua</option>
            <option value="SO" class="State-Options MX-State">Sonora</option>
            <option value="CO" class="State-Options MX-State">Coahuila</option>
            <option value="DU" class="State-Options MX-State">Durango</option>
            <option value="OA" class="State-Options MX-State">Oaxaca</option>
            <option value="TM" class="State-Options MX-State">Tamaulipas</option>
            <option value="JA" class="State-Options MX-State">Jalisco</option>
            <option value="ZA" class="State-Options MX-State">Zacatecas</option>
            <option value="BS" class="State-Options MX-State">Baja California Sur</option>
            <option value="CP" class="State-Options MX-State">Chiapas</option>
            <option value="VE" class="State-Options MX-State">Veracruz</option>
            <option value="BC" class="State-Options MX-State">Baja California</option>
            <option value="NL" class="State-Options MX-State">Nuevo León</option>
            <option value="GR" class="State-Options MX-State">Guerrero</option>
            <option value="SL" class="State-Options MX-State">San Luis Potosí</option>
            <option value="MI" class="State-Options MX-State">Michoacán</option>
            <option value="SI" class="State-Options MX-State">Sinaloa</option>
            <option value="CM" class="State-Options MX-State">Campeche</option>
            <option value="QR" class="State-Options MX-State">Quintana Roo</option>
            <option value="YU" class="State-Options MX-State">Yucatán</option>
            <option value="PU" class="State-Options MX-State">Puebla</option>
            <option value="GT" class="State-Options MX-State">Guanajuato</option>
            <option value="NA" class="State-Options MX-State">Nayarit</option>
            <option value="TA" class="State-Options MX-State">Tabasco</option>
            <option value="EM" class="State-Options MX-State">Estado de México</option>
            <option value="HI" class="State-Options MX-State">Hidalgo</option>
            <option value="QE" class="State-Options MX-State">Querétaro</option>
            <option value="CL" class="State-Options MX-State">Colima</option>
            <option value="AG" class="State-Options MX-State">Aguascalientes</option>
            <option value="MO" class="State-Options MX-State">Morelos</option>
            <option value="TL" class="State-Options MX-State">Tlaxcala</option>
            <option value="MX" class="State-Options MX-State">Ciudad de México</option>

            <option value="AB" class="State-Options CA-State">Alberta</option>
            <option value="BC" class="State-Options CA-State">British Columbia</option>
            <option value="MB" class="State-Options CA-State">Manitoba</option>
            <option value="NB" class="State-Options CA-State">New Brunswick</option>
            <option value="NL" class="State-Options CA-State">Newfoundland and Labrador</option>
            <option value="NS" class="State-Options CA-State">Nova Scotia</option>
            <option value="ON" class="State-Options CA-State">Ontario</option>
            <option value="PE" class="State-Options CA-State">Prince Edward Island</option>
            <option value="QC" class="State-Options CA-State">Quebec</option>
            <option value="SK" class="State-Options CA-State">Saskatchewan</option>
            <option value="NT" class="State-Options CA-State">Northwest Territories</option>
            <option value="YT" class="State-Options CA-State">Yukon</option>
            <option value="NU" class="State-Options CA-State">Nunavut</option>

            <option value="CM" class="State-Options TH-State">Chiang Mai</option>
            <option value="PT" class="State-Options TH-State">Phetchaburi</option>
            <option value="CR" class="State-Options TH-State">Chiang Rai</option>
            <option value="TK" class="State-Options TH-State">Tak</option>
            <option value="PK" class="State-Options TH-State">Prachuap Khiri Khan</option>
            <option value="KB" class="State-Options TH-State">Krabi</option>
            <option value="LN" class="State-Options TH-State">Lamphun</option>
            <option value="KP" class="State-Options TH-State">Kamphaeng Phet</option>
            <option value="PG" class="State-Options TH-State">Phangnga</option>
            <option value="PL" class="State-Options TH-State">Phitsanulok</option>
            <option value="ST" class="State-Options TH-State">Nakhon Si Thammarat</option>
            <option value="UT" class="State-Options TH-State">Uthai Thani</option>
            <option value="NN" class="State-Options TH-State">Nan</option>
            <option value="KK" class="State-Options TH-State">Kanchanaburi</option>
            <option value="SR" class="State-Options TH-State">Surat Thani</option>
            <option value="SN" class="State-Options TH-State">Satun</option>
            <option value="NK" class="State-Options TH-State">Nakhon Ratchasima</option>
            <option value="SH" class="State-Options TH-State">Songkhla</option>
            <option value="PB" class="State-Options TH-State">Phetchabun</option>
            <option value="NY" class="State-Options TH-State">Nakhon Nayok</option>
            <option value="SI" class="State-Options TH-State">Sukhothai</option>
            <option value="LE" class="State-Options TH-State">Loei</option>
            <option value="HH" class="State-Options TH-State">Mae Hong Son</option>
            <option value="CB" class="State-Options TH-State">Chon Buri</option>
            <option value="CM" class="State-Options TH-State">Chaiyaphum</option>
            <option value="CP" class="State-Options TH-State">Chumphon</option>
            <option value="NS" class="State-Options TH-State">Nakhon Sawan</option>
            <option value="RT" class="State-Options TH-State">Ratchaburi</option>
            <option value="TG" class="State-Options TH-State">Trang</option>
            <option value="LP" class="State-Options TH-State">Lampang</option>
            <option value="NT" class="State-Options TH-State">Narathiwat</option>
            <option value="CC" class="State-Options TH-State">Chachoengsao</option>
            <option value="RY" class="State-Options TH-State">Rayong</option>
            <option value="YL" class="State-Options TH-State">Yala</option>
            <option value="UD" class="State-Options TH-State">Uttaradit</option>
            <option value="PL" class="State-Options TH-State">Phatthalung</option>
            <option value="KK" class="State-Options TH-State">Khon Kaen</option>
            <option value="CE" class="State-Options TH-State">Chanthaburi</option>
            <option value="BK" class="State-Options TH-State">Krung Thep Maha Nakhon [Bangkok]</option>
            <option value="RG" class="State-Options TH-State">Ranong</option>
            <option value="SP" class="State-Options TH-State">Samut Prakan</option>
            <option value="PB" class="State-Options TH-State">Prachin Buri</option>
            <option value="PU" class="State-Options TH-State">Phuket</option>
            <option value="TT" class="State-Options TH-State">Trat</option>
            <option value="BR" class="State-Options TH-State">Buri Ram</option>
            <option value="PY" class="State-Options TH-State">Phayao</option>
            <option value="SB" class="State-Options TH-State">Saraburi</option>
            <option value="NP" class="State-Options TH-State">Nakhon Pathom</option>
            <option value="PC" class="State-Options TH-State">Phichit</option>
            <option value="UD" class="State-Options TH-State">Udon Thani</option>
            <option value="SS" class="State-Options TH-State">Samut Sakhon</option>
            <option value="PN" class="State-Options TH-State">Pattani</option>
            <option value="LB" class="State-Options TH-State">Lop Buri</option>
            <option value="PT" class="State-Options TH-State">Pathum Thani</option>
            <option value="SK" class="State-Options TH-State">Sa Kaeo</option>
            <option value="UB" class="State-Options TH-State">Ubon Ratchathani</option>
            <option value="SP" class="State-Options TH-State">Suphan Buri</option>
            <option value="SM" class="State-Options TH-State">Samut Songkhram</option>
            <option value="AY" class="State-Options TH-State">Phra Nakhon Si Ayutthaya</option>
            <option value="NK" class="State-Options TH-State">Nong Khai</option>
            <option value="PR" class="State-Options TH-State">Phrae</option>
            <option value="MS" class="State-Options TH-State">Maha Sarakham</option>
            <option value="SI" class="State-Options TH-State">Si Sa Ket</option>
            <option value="SN" class="State-Options TH-State">Surin</option>
            <option value="BK" class="State-Options TH-State">Bueng Kan</option>
            <option value="NB" class="State-Options TH-State">Nonthaburi</option>
            <option value="YS" class="State-Options TH-State">Yasothon</option>
            <option value="RE" class="State-Options TH-State">Roi Et</option>
            <option value="NP" class="State-Options TH-State">Nakhon Phanom</option>
            <option value="MD" class="State-Options TH-State">Mukdahan</option>
            <option value="SN" class="State-Options TH-State">Sakon Nakhon</option>
            <option value="AC" class="State-Options TH-State">Amnat Charoen</option>
            <option value="KS" class="State-Options TH-State">Kalasin</option>
            <option value="CN" class="State-Options TH-State">Chai Nat</option>
            <option value="NB" class="State-Options TH-State">Nong Bua Lam Phu</option>
            <option value="AT" class="State-Options TH-State">Ang Thong</option>
            <option value="SB" class="State-Options TH-State">Sing Buri</option>


          </select>
        </div>
        <div class="col dis_1">

          <input type="text" class="form-control" aria-label="Zip Code/Postal Code *"
            placeholder="Zip Code/Postal Code *" [(ngModel)]="user.Zipcode" name="Zipcode">
        </div>
      </div>
      <div class="row sp-fm0">
        <div class="col dis_1">
          <input type="email" class="form-control" aria-label="Email *" placeholder="Email *" [(ngModel)]="user.Email"
            name="Email">
        </div>
        <div class="col dis_1">

          <input type="text" class="form-control" aria-label="Phone *" placeholder="Phone *"
            [(ngModel)]="user.PhoneNumber" name="PhoneNumber">
        </div>
      </div>
      <div class="row row-new sp-fm0">
        <div class="col-md-6 dis_1 ">
          <select id="inputState" aria-label="How Can We Help" class="form-select ds" [(ngModel)]="user.HowCanWeHelp"
            name="HowCanWeHelp">
            <option value="" disabled selected>How can we help? *</option>
            <option value="4" *ngIf="!hideServiceInquiry">I have a service inquiry about my UPS Capital policy</option>
            <option value="1">I'm interested in your services</option>
          </select>
        </div>
        <div class="col col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsState">


          <div class="g-recaptcha" data-callback="recaptchaCallback"
            data-sitekey="6LeWTwUcAAAAAP0S-FWFcCQqwCB7Bc1tj6uOegT_"></div>
        </div>
        <div class="col  col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsZip">
          <div class="hero-panel-button sli-btn form-submit">
            <button class="get-secret-btn form-sub submit-form" tabindex="-1" type="submit">Submit
            </button>
          </div>
        </div>


      </div>

    </form>
  </div>

  <div class="row-common new-basic bus-ic max-1200 superior-coverage sub-heading container-fluid" id="skip-to-main">
    <h2 class="comm-head">
      Support When You Need It</h2>
    <p class="text-center">Understand UPS Capital solutions, claims guides, and contact information.</p>
    <p></p>

  </div>


  <div class="row  shp-bgo cont-bg0">
    <div class="col-md-4 max-1200  ic-01 ">
      <div class="text-center  img-tag">
        <img class="rounded d-block ico-img" alt="contact-us" src="../../../../assets/redesignImages/privacy_tip.png" />
      </div>

      <div class="wrapper wrap-bus">

        <p class="tit-0 maj">Find Out What Services We Offer</p>

        <div class="hero-panel-button tit-0 ">
          <a class="get-secret-btn btn-wrap button-1" tabindex="-1" target="_blank"
            href="../../../../assets/UPS_Capital_Solutions_Directory.pdf" rel="noopener">View Solutions
            <img class="blue-tags" alt="contact-us" src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>

    </div>
    <div class="col-md-4 ic-02">
      <div class="text-center img-tag">
        <img class="ico-img rounded d-block" alt="contact-us" src="../../../../assets/redesignImages/computer.png" />
      </div>
      <div class="wrapper wrap-bus">
        <p class="tit-0 maj ">File a UPS Capital Claim
        </p>
        <div class="hero-panel-button tit-0 ">
          <a class=" btn-wrap get-secret-btn button-2" tabindex="-1" target="_blank"
            href="../../../../assets/UPS_Capital_Claims_Guide_Directory.pdf" rel="noopener">View Claims Guide
            <img class="blue-tags" alt="contact-us" src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>
    </div>
    <div class="col-md-4 ic-02 ">
      <div class="text-center img-tag">
        <img class="ico-img rounded d-block" alt="contact-us"
          src="../../../../assets/redesignImages/support_agent.png" />
      </div>
      <div class="wrapper wrap-bus tit-0">
        <p class="tit-0 maj">Get In Touch
          With Us</p>
        <div class="hero-panel-button tit-0">
          <a class="btn-wrap get-secret-btn button-3" tabindex="-1" target="_blank"
            href="../../../../assets/UPS_Capital_Customer_Support_Office_Directory.pdf" rel="noopener">Customer
            Support <img class="blue-tags" alt="contact-us" src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>
    </div>
  </div>

  <div class="row-common new-basic bus-ic max-1200 superior-coverage sub-heading container-fluid" id="skip-to-main">
    <h2 class="comm-head">
      Have a UPS<sup class="sup-h">®</sup> Question?</h2>
    <p class="text-center">Let’s make sure we get you to the right place.</p>
    <p></p>
  </div>

  <div class="row  shp-bgo cont-bg0">
    <div class="col-md-4 max-1200  ic-01 marg ">
      <div class="text-center  img-tag">
        <img class="rounded d-block ico-img" alt="contact-us" src="../../../../assets/redesignImages/description.png" />
      </div>

      <div class="wrapper wrap-bus">

        <p class="tit-0 maj">UPS Claims</p>
        <p class="tit-0 sml">Submit or manage a UPS claim.
        </p>
        <div class="hero-panel-button tit-0 ">
          <a class="get-secret-btn btn-wrap button-4" tabindex="-1" href="https://www.ups.com/claims/create"
            target="_blank" rel="noopener">Log in to
            File UPS Claim
            <img class="arrow-head-padding" alt="contact-us" src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>

    </div>
    <div class="col-md-4 ic-02">
      <div class="text-center img-tag">
        <img class="ico-img rounded d-block" alt="contact-us"
          src="../../../../assets/redesignImages/account_tree.png" />
      </div>
      <div class="wrapper wrap-bus">
        <p class="tit-0 maj ">UPS Package Status
        </p>
        <p class="tit-0 sml">Details on shipping, tracking and delivery.</p>
        <div class="hero-panel-button tit-0 ">
          <a class=" btn-wrap get-secret-btn button-5" tabindex="-1" href=" https://www.ups.com/track" target="_blank"
            rel="noopener">Track
            Package <img class="arrow-head-padding" alt="contact-us"
              src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>
    </div>
    <div class="col-md-4 ic-02 ">
      <div class="text-center img-tag">
        <img class="ico-img rounded d-block" alt="contact-us" src="../../../../assets/redesignImages/credit_card.png" />
      </div>
      <div class="wrapper wrap-bus tit-0">
        <p class="tit-0 maj">UPS Billing & Payment</p>
        <p class="tit-0 sml">Questions about your UPS invoice or UPS account.
        </p>
        <div class="hero-panel-button tit-0">
          <a class="btn-wrap get-secret-btn button-6" tabindex="-1" target="_blank" href="http://billing.ups.com/home"
            rel="noopener">UPS Billing
            Center <img class="arrow-head-padding" alt="contact-us"
              src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>
    </div>
  </div>

  <div class="row-common new-basic bus-ic max-1200 superior-coverage sub-heading container-fluid" id="skip-to-main">
    <h2 class="comm-head">
      Frequently Asked Questions</h2>
    <p></p>

  </div>

  <div class="accordion" id="accordionExample">
    <p class="accordion-subheading pw100-width">Claims</p>
    <div class="accordion-item">
      <h2 class="accordion-header media-margin" id="headingOne">
        <button class="margin-acc-value accordion-button-media accordion-button collapsed accordion-colour"
          type="button" aria-expanded="false" aria-controls="collapseOne" (click)="toggleAccordion('collapseOne')">
          What documents are needed to support my claim?
        </button>
      </h2>
      <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          Each claim is different and as a result, may require different documents. However, almost all claims require
          proof of loss and documentation reflecting the value of the loss, such as an invoice or bill of sale. In
          addition, the following items may also be requested: freight invoice, packing list, replacement invoice,
          repair estimate, photos of the goods and packaging and, if lost, a police report or statement of non-receipt
          by the receiver.
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header media-margin" id="headingTwo">
        <button class="margin-acc-value accordion-button collapsed accordion-colour" type="button"
          data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"
          (click)="toggleAccordion('collapseTwo')">
          When should I report a claim?
        </button>
      </h2>
      <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          If you experience a loss or damage, you must file a claim as soon as possible. This will provide the adjuster
          time to identify any needed steps or documentation so you can be paid in a timely fashion.
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header media-margin" id="headingThree">
        <button class="margin-acc-value accordion-button collapsed accordion-colour" type="button"
          data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"
          (click)="toggleAccordion('collapseThree')">
          How can I check the status of my claim?
        </button>
      </h2>
      <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          For participating countries, the claims portal can be accessible. Simply log in and view the Claims tab to
          find all your claims.<br>

          If you do not have a claims portal, you would be notified via email. If you do not hear back within 5 days,
          please refer to the Customer Support Directory to locate your country’s customer support contact information.
        </div>
      </div>
    </div>
    <p class="accordion-subheading pw100-width">Products</p>
    <div class="accordion-item ">
      <h2 class="accordion-header" id="headingFour">
        <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour"
          (click)="toggleAccordion('collapseFour')">
          What is covered under business services?
        </button>
      </h2>
      <div id="collapseFour" class="accordion-collapse collapse " aria-labelledby="headingFour"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          Access to solutions to assist with growth, payments, and imports. </div>
      </div>
    </div>

    <div class="accordion-item">
      <h2 class="accordion-header" id="headingSix">
        <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseThree"
          (click)="toggleAccordion('collapseSix')">
          What are Payment Services?
        </button>
      </h2>
      <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          Secure, affordable payment solutions for businesses such as:
          <ul>
            <li>Merchant Services: Accept and secure card payments simply with Chase partnership through
              over-the-counter,
              website or mobile devices. Receive clear pricing with competitive rates (no hidden fees). Read more about
              Merchant Services</li>
            <li>Enhanced C.O.D Services: Expedite payments, protect your cash flow and manage customer check deposits
              with
              enhanced C.O.D. payment options. Read more about Enhanced C.O.D Services</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingSeven">
        <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseThree"
          (click)="toggleAccordion('collapseSeven')">
          What is Enhanced Carrier Protection?
        </button>
      </h2>
      <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          Address potential risks by protecting your cash flow and reputation from the unique challenges that come with
          transporting valuable goods. Work with a representative to discuss the best protection option for your
          products and supply chain. Get access to a UPS approved software to choose which shipments to protect. Pay as
          you go with charges being included in your regular UPS invoice.
          <br>
          <br>
          Fill out the form or contact Customer Support
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingEight">
        <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseThree"
          (click)="toggleAccordion('collapseEight')">
          What is Cargo Insurance?
        </button>
      </h2>
      <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          Get cargo insurance through InsureShield® Shipping Insurance with carrier liability limits and covered retail
          cost for goods in transit, regardless of mode or carrier. Get in touch with a Sales Representative to discuss
          what option fits best for your business. Only in participating countries, please refer to Solutions Offerings.
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingNine">
        <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseThree"
          (click)="toggleAccordion('collapseNine')">
          What is Freight Forwarding Liability Insurance?
        </button>
      </h2>
      <div id="collapseNine" class="accordion-collapse collapse" aria-labelledby="headingNine"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          Reduce financial risks to your business and get comprehensive protection. Forwarders are responsible for
          third-party goods under their control. With freight forwarding liability insurance, get protection against
          cargo liability, error and omission, damage or loss, fines and penalties, legal and investigation costs.
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingTen">
        <button class="accordion-button collapsed accordion-colour" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseThree"
          (click)="toggleAccordion('collapseTen')">
          What is Parcel Pro Select?
        </button>
      </h2>
      <div id="collapseTen" class="accordion-collapse collapse" aria-labelledby="headingTen"
        data-bs-parent="#accordionExample">
        <div class="accordion-body body-with-no-padding">
          ParcelPro® Select insures high-value goods shipping. Your valuables can travel safely across the world with
          white-glove services. Fill out the form or contact your customer support team to see how this can help your
          business.
          <br>
          <br>
          For participating countries, please review the solutions offered in your country directory sheet.
        </div>
      </div>
    </div>
  </div>


  <p></p>
  <p></p>
  <p></p>
</div>